module.exports = __webpack_public_path__ + "static/media/clipboard-icon-grey.9278a0e9.svg";